<script setup lang="ts">
import type { CmsBlockGalleryBuybox } from "@shopware/composables";
import { useCmsBlock } from "#imports";

const props = defineProps<{
  content: CmsBlockGalleryBuybox;
}>();

const { getSlotContent } = useCmsBlock(props.content);
const rightContent = getSlotContent("right");
const leftContent = getSlotContent("left");
</script>
<template>
  <section class="prodSec">
    <div
      class="flex flex-wrap mb-10 md:mb-20 lg:mb-24 xl:mb-40 md:mt-2 lg:mt-16 xl:mt-24"
    >
      <div class="w-full lg:w-[45%] xl:w-1/2 p-0 xl:pe-7">
        <CmsGenericElement :content="leftContent" />
      </div>
      <div
        class="w-full lg:w-[55%] xl:w-1/2 font-redit_sans font-light lg:ps-6 xl:ps-14"
      >
        <CmsGenericElement :content="rightContent" />
      </div>
    </div>
  </section>
</template>
